import { APIResponse } from '../../../server/routes/route-types.js';

// export function sharedGET(url, callbacks) {
//         return sharedFetch(url, "GET", null, callbacks)
//     }

interface Callbacks {
    onSuccess: (response: APIResponse<{}>) => void;
    onError: (error: string) => void;
    onFailure?: (error: string) => void;
}

export default function sharedPOST(url: string, postParameters: Record<string, wts_approved_any>, callbacks: Callbacks): void {
        return sharedFetch(url, "POST", postParameters, callbacks)
    }

function sharedFetch(url: string, method: string, postParameters: Record<string, wts_approved_any>, callbacks: Callbacks): void {

    if (!callbacks || !callbacks.onSuccess || !callbacks.onError) {
        console.log(`Callbacks not defined properly`);
        return;
    }

    fetch( url, {
        method: method,
        headers: !postParameters ? undefined : { 'Content-Type': 'application/json' },
        body: !postParameters ? undefined : 
            JSON.stringify(
                postParameters
            )
    }).then(( response ) => {
        return response.json();
    }).then(( response: APIResponse<{}> ) => {
        if (!response.err) {
            callbacks.onSuccess(response);
        }
        else {
            callbacks.onError(response.err);
        }
    }).catch(( e ) => {
            console.log(e.message)
            if (callbacks.onFailure) {
                callbacks.onFailure('Unexpected error');
            }
            else {
                callbacks.onError(e.stack);
            }
    });
}
